import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

class LoaderRing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      radius: 8,
      ringLength: 2 * Math.PI * 8,
    };
  }

  componentDidMount() {
    const { ringLength } = this.state;
    const { deadline, loops } = this.props;

    let length = 30000;
    let iterations = Infinity;
    let end;
    let duration = 30000;
    const now = moment();

    if (deadline) {
      end = moment.unix(deadline);
      if (end && now) {
        duration = moment.duration(end.diff(now));
      }
    }
    if (loops) {
      iterations = loops;
    }
    if (duration) {
      length = duration.asMilliseconds();
    }

    const ringAnim = [
      { strokeDashoffset: '0px' },
      { strokeDashoffset: `${ringLength || 0}px` },
    ];

    const ringTiming = {
      duration: Math.abs(length),
      iterations,
    };
    const ring = document.getElementById('ring');

    if (ring && length && iterations && ringAnim && ringTiming) {
      ring.animate(
        ringAnim,
        ringTiming,
      );
    }
  }

  render() {
    const { radius, ringLength } = this.state;

    const svgStyle = {
      'width': 24,
      'height': 24,
    };
    const ringStyle = {
      strokeDasharray: ringLength,
      strokeDashoffset: ringLength,
    };

    return (
      <div className="loader-ring">
        <svg id="loader-ring" style={svgStyle}>
          <circle id="bg" cx={radius + 4} cy={radius + 4} r={radius} strokeWidth="2" />
          <circle id="ring" cx={radius + 4} cy={radius + 4} r={radius} strokeWidth="2" style={ringStyle} />
        </svg>
      </div>
    );
  }
}

export default withRouter(LoaderRing);
